import { useState } from "react";
import { ChevronDownIcon } from "~/icons";
import type { ProductCategory } from "~/types";
import { Box } from "../Box/Box";
import { CategorySelectionModal } from "../CategorySelectionModal/CategorySelectionModal";
import { Text } from "../Text/Text";

export function CategoryDropdown({
  menu,
  selectedCategory,
  onSelectCategory,
}: {
  menu: ProductCategory[];
  selectedCategory: ProductCategory | undefined;
  onSelectCategory: (category: ProductCategory) => void;
}): React.ReactNode {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        background="white"
        border="standard"
        borderColor="neutral-300"
        borderRadius="standard"
        height="touchable"
        paddingX="3"
        onClick={() => setOpen(true)}
        role="combobox"
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-labelledby="category-dropdown-label"
        style={{ border: "1px solid var(--color-neutral-300)", flex: 1 }}
      >
        <Text id="category-dropdown-label">{selectedCategory?.title}</Text>
        <Box
          alignItems="center"
          display="flex"
          height="touchable"
          style={{ marginLeft: "auto" }}
          aria-hidden="true"
        >
          <ChevronDownIcon />
        </Box>
      </Box>
      <CategorySelectionModal
        menu={menu}
        onClose={() => setOpen(false)}
        open={open}
        onSelectCategory={(category) => {
          onSelectCategory(category);
          setOpen(false);
        }}
      />
    </>
  );
}
